import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Mail, Phone, MapPin } from 'lucide-react';
import { getWhatsAppUrl } from '../config/constants';
import { CONFIG } from '../config/constants';
import { Link } from 'react-router-dom';

import logo from '../assets/logo-w.png'
import ig from '../assets/ig.png'
import fb from '../assets/fb.png';;

const Footer = () => {
    const socialLinks = [
        { name: 'Instagram', icon: ig, url: 'https://www.instagram.com/print_studio_m' },
        { name: 'Facebook', icon: fb, url: 'https://www.facebook.com/share/1G1LHuNzmg/?mibextid=wwXIfr' },
    ];;

    const quickLinks = [
        { name: 'Home', url: '#home' },
        { name: 'About', url: '#about' },
        { name: 'Services', url: '#services' },
        { name: 'Products', url: '#products' },
    ];

    const whatsappUrl = getWhatsAppUrl()
    const getPhone = CONFIG.COMPANY.PHONE
    const getAddress = CONFIG.COMPANY.ADDRESS
    const getEmail = CONFIG.COMPANY.EMAIL

    return (
        <footer id="footer" className="bg-black text-white relative overflow-hidden">
            {/* Stars */}
            <div className="absolute inset-0">
                {[...Array(50)].map((_, s) => (
                    <motion.div
                        key={s}
                        className="absolute w-1 h-1 bg-secondary rounded-full"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                        }}
                        animate={{
                            opacity: [0.2, 1, 0.2],
                            scale: [1, 1.5, 1],
                        }}
                        transition={{
                            duration: Math.random() * 3 + 2,
                            repeat: Infinity,
                            delay: Math.random() * 2,
                        }}
                    />
                ))}
            </div>
            {/* Animated background elements */}
            <div className="absolute inset-0 overflow-hidden">
                {[...Array(15)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute rounded-full bg-gradient-to-r from-primary/10 to-secondary/10"
                        style={{
                            width: Math.random() * 200 + 50,
                            height: Math.random() * 200 + 50,
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                        }}
                        animate={{
                            y: [0, -50, 0],
                            x: [0, 30, 0],
                            rotate: [0, 180, 360],
                        }}
                        transition={{
                            duration: Math.random() * 15 + 10,
                            repeat: Infinity,
                            ease: "linear",
                        }}
                    />
                ))}
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
                    {/* Brand Section */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        className="lg:col-span-2"
                    >
                        <h3 className="text-3xl font-bold gradient-text mb-4 drop-shadow-md">
                            <div className="flex-shrink-0">
                                <Link to={`inicio`} className="flex items-center">
                                    <img
                                        src={logo}
                                        alt="Print Studio"
                                        className="h-32 w-auto smooth-transition hover:scale-150"
                                    />
                                </Link>
                            </div>
                        </h3>
                        <p className="text-white mb-6 text-lg">

                            Transformando ideas en experiencias visuales extraordinarias. Creemos juntos algo extraordinario que capture la esencia de tu marca y cautive a tu audiencia.
                        </p>
                        <motion.a
                            href={whatsappUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full inline-flex items-center space-x-2 smooth-transition hover-glow"
                        >
                            <MessageCircle size={20} />
                            <span>Escríbenos por WhatsApp</span>
                        </motion.a>
                    </motion.div>

                    {/* Contact Info */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <h4 className="text-xl font-semibold mb-4 text-accent">¡Contáctanos!</h4>
                        <div className="space-y-3">
                            <div className="flex items-center space-x-3 text-white">
                                <Phone size={18} className="text-primary" />
                                <span>{getPhone}</span>
                            </div>
                            <div className="flex items-center space-x-3 text-white">
                                <Mail size={18} className="text-primary" />
                                <span>{getEmail}</span>
                            </div>
                            <div className="flex items-center space-x-3 text-white">
                                <MapPin size={18} className="text-primary" />
                                <span>{getAddress}</span>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* Social Links */}
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.6 }}
                    className="flex justify-center space-x-6 mb-8"
                >
                    {socialLinks.map((link, index) => (
                        <motion.a
                            key={index}
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-2xl hover:scale-125 smooth-transition"
                            whileHover={{ scale: 1.2, y: -5 }}
                            whileTap={{ scale: 0.9 }}
                        >
                            <img
                                src={link.icon}
                                alt={link.name}
                                style={{ width: '40px', height: '40px' }}
                            />
                        </motion.a>
                    ))}
                </motion.div>

                {/* Bottom Bar */}
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.8 }}
                    className="border-t border-gray-700 pt-8 text-center"
                >
                    <p className="text-white">
                        © {new Date().getFullYear()} Print Studio. All rights reserved.
                    </p>
                </motion.div>
            </div>
        </footer>
    );
};

export default Footer;